<template>
  <div class="setting-page">
    <section class="profile-card">
      <div class="profile-top">
        <div class="avatar">
          {{ userInitial }}
        </div>
        <div class="profile-meta">
          <span class="muted">{{ $t("setting.name") }}</span>
          <strong>{{ $store.state.authUser.name }}</strong>
          <span class="phone">{{ $store.state.authUser.phone }}</span>
        </div>
      </div>

      <div class="balance-box">
        <div>
          <span class="muted">{{ $t("setting.balance") }}</span>
          <div class="balance-value">
            <b>{{ Number($store.state.amount).toLocaleString() }}</b>
            <span>Unit</span>
          </div>
        </div>
        <div class="withdraw-box">
          <span class="muted">{{ $t("setting.withdraw") }}</span>
          <b>{{ Number($store.state.totalWithdraw).toLocaleString() }}</b>
        </div>
      </div>
    </section>

    <section class="quick-grid">
      <button type="button" class="quick-card" @click="go('/deposit')">
        <img
          src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Deposit%20(4).png"
          alt=""
        />
        <span>{{ $t("setting.deposit") }}</span>
      </button>
      <button type="button" class="quick-card" @click="go('/withdraw')">
        <img
          src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Withdraw%20(2).png"
          alt=""
        />
        <span>{{ $t("setting.withdraw") }}</span>
      </button>
      <button type="button" class="quick-card" @click="go('/history')">
        <img
          src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Money%20List.png"
          alt=""
        />
        <span>{{ $t("setting.transaction") }}</span>
      </button>
      <button type="button" class="quick-card" @click="go('/betslip-history')">
        <img
          src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Voucher%20(2).png"
          alt=""
        />
        <span>{{ $t("setting.voucher") }}</span>
      </button>
    </section>

    <section class="setting-list">
      <div class="list-item">
        <div class="list-left">
          <img
            src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Name%20(1).png"
            alt=""
          />
          <span>{{ $t("setting.name") }} - {{ $store.state.authUser.user_name }}</span>
        </div>
      </div>

      <button
        type="button"
        class="list-item"
        @click="
          $playSound();
          showPasswordModal = true;
        "
      >
        <div class="list-left">
          <img
            src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Password.png"
            alt=""
          />
          <span>{{ $t("setting.update_password") }}</span>
        </div>
        <i class="fas fa-chevron-right"></i>
      </button>

      <button type="button" class="list-item" @click="go('/rule')">
        <div class="list-left">
          <img
            src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Rules.png"
            alt=""
          />
          <span>{{ $t("setting.rule") }}</span>
        </div>
        <i class="fas fa-chevron-right"></i>
      </button>

      <div class="list-item">
        <div class="list-left">
          <img
            src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Sound.png"
            alt=""
          />
          <span>{{ $t("setting.sound") }}</span>
        </div>
        <van-switch
          :value="$store.state.music"
          active-color="#e7b534"
          inactive-color="#dcdee0"
          @click="onOffMusic()"
        />
      </div>

      <div class="list-item language-item" @click="toggleLanguages">
        <div class="list-left">
          <img
            src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Language.png"
            alt=""
          />
          <span>{{ $t("setting.update_language") }}</span>
        </div>
        <i class="fas fa-chevron-right" :class="{ open: showLanguages }"></i>
        <div class="lang-options" v-if="showLanguages">
          <button type="button" @click.stop="setLangLocalstorage('en')">
            <img
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/united-kingdom.png"
              alt=""
            />
            {{ $t("en") }}
          </button>
          <button type="button" @click.stop="setLangLocalstorage('mm')">
            <img
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/myanmar.png"
              alt=""
            />
            {{ $t("mm") }}
          </button>
          <button type="button" @click.stop="setLangLocalstorage('cn')">
            <img
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
              alt=""
            />
            {{ $t("cn") }}
          </button>
          <button type="button" @click.stop="setLangLocalstorage('th')">
            <img
              src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
              alt=""
            />
            {{ $t("th") }}
          </button>
        </div>
      </div>

      <button type="button" class="list-item" @click="go('/home')">
        <div class="list-left">
          <img
            src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Exit.png"
            alt=""
          />
          <span>{{ $t("back_to_home") }}</span>
        </div>
      </button>
    </section>

    <button
      type="button"
      class="logout-btn"
      @click="logout"
      :disabled="isLoggingOut"
    >
      <Loading v-if="isLoggingOut" size="20" color="#f7d56a" />
      <span v-else>{{ $t("setting.logout") }}</span>
    </button>

    <van-popup
      v-model="showPasswordModal"
      round
      closeable
      position="bottom"
      class="password-popup"
    >
      <div class="password-modal">
        <h5>{{ $t("setting.update_password") }}</h5>
        <label>{{ $t("setting.old_password") }}</label>
        <input class="form-control" v-model="password.old" type="password" />
        <span class="error-text">{{ errors.old }}</span>
        <label>{{ $t("setting.new_password") }}</label>
        <input class="form-control" v-model="password.new" type="password" />
        <span class="error-text">{{ errors.new }}</span>
        <label>{{ $t("setting.confirm_password") }}</label>
        <input
          class="form-control"
          v-model="password.confirm"
          type="password"
        />
        <span class="error-text">{{
          errors.confirm || errors.confirmPassword
        }}</span>
        <button type="button" class="update-btn" @click="onUpdatePassword">
          <span v-if="!isConfirm">{{ $t("setting.update") }}</span>
          <Loading
            color="#1a1408"
            v-if="isConfirm"
            size="22"
            class="px-4 py-0"
          />
        </button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from "vant";
import { mapActions } from "vuex";

export default {
  components: { Loading },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      isConfirm: false,
      errors: {},
      showLanguages: false,
      showPasswordModal: false,
      isLoggingOut: false,
    };
  },
  computed: {
    userInitial() {
      const label =
        this.$store.state.authUser.phone ||
        this.$store.state.authUser.name ||
        "U";
      return String(label).charAt(0).toUpperCase();
    },
  },
  methods: {
    ...mapActions(["logoutUser", "fetchUser"]),
    go(path) {
      this.$playSound();
      this.$router.push(path);
    },
    onOffMusic() {
      this.$playSound();
      this.$store.commit("setMusic", !this.$store.state.music);
    },
    toggleLanguages() {
      this.$playSound();
      this.showLanguages = !this.showLanguages;
    },
    setLangLocalstorage(language) {
      this.$playSound();
      localStorage.setItem("language", language);
      this.$store.commit("setLanguage", language);
      this.$i18n.locale = language;
    },
    onUpdatePassword() {
      this.$playSound();
      this.changeNewPassword();
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === "en"
            ? "Old password required"
            : "လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။";
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === "en"
            ? "New password required"
            : "လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။";
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === "en"
            ? "Confirm password required"
            : "အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။";
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === "en"
            ? "New passwords not match"
            : "လျှို့ဝှက်နံပါတ် မတူညီပါ။";
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === "en"
            ? "Are you sure?"
            : "သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မလုပ်တော့ပါ။",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ။",
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => {});
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        await axios.post("/auth/userPasswordChange", this.password, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        Toast.success(
          this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။"
        );
        this.password = {
          user_id: this.$store.state.authUser.id,
        };
        this.errors = {};
        this.showPasswordModal = false;
      } catch (error) {
        Toast.fail(
          this.$store.state.language === "en" ? "Fail" : "ကျရှုံးသည်။"
        );
      }
    },
    async logout() {
      if (this.isLoggingOut) return;
      this.$playSound();
      this.isLoggingOut = true;
      try {
        await this.logoutUser();
        Toast.success(
          this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
        );
        this.$router.push("/welcome");
      } catch (error) {
        this.isLoggingOut = false;
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
  },
};
</script>
<style scoped>
.setting-page {
  min-height: 100vh;
  padding: 12px 14px 8rem;
  color: #f5f5f5;
  background: #0c0c0c;
}

.profile-card,
.quick-card,
.list-item {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #1c1c1c;
}

.profile-card {
  padding: 14px;
  border-radius: 16px;
}

.profile-top {
  display: flex;
  align-items: center;
}

.avatar {
  width: 48px;
  height: 48px;
  margin-right: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #1a1408;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
}

.profile-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.profile-meta strong {
  font-size: 1.05rem;
  color: #fff;
}

.phone {
  color: #d8c48a;
  font-size: 0.82rem;
}

.muted {
  display: block;
  font-size: 0.72rem;
  color: #b8b3a8;
}

.balance-box {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.balance-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
  color: #f7d56a;
}

.balance-value b,
.withdraw-box b {
  font-size: 1.2rem;
  color: #f7d56a;
}

.quick-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 12px;
}

.quick-card {
  min-height: 78px;
  border-radius: 14px;
  color: #f0e6c8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.quick-card:active,
.list-item:active {
  background: #1a1a1a;
}

.quick-card img {
  width: 24px;
  height: 24px;
}

.quick-card span {
  margin-top: 6px;
  font-size: 0.8rem;
  font-weight: 600;
}

.setting-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.list-item {
  width: 100%;
  min-height: 52px;
  padding: 10px 12px;
  border-radius: 14px;
  color: #f0e6c8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}

.list-left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.list-left img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.list-item i {
  font-size: 0.72rem;
  color: #d8c48a;
}

.language-item {
  flex-wrap: wrap;
}

.language-item i.open {
  transform: rotate(90deg);
}

.lang-options {
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 10px;
}

.lang-options button {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  background: #171717;
  color: #f0e6c8;
  font-size: 0.8rem;
}

.lang-options img {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  border-radius: 50%;
}

.logout-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.logout-btn {
  width: 100%;
  margin-top: 14px;
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  background: #242424;
  color: #f7d56a;
  font-weight: 700;
}

.password-modal {
  padding: 20px 16px 28px;
  background: #161616;
  border-radius: 16px;
  color: #f5f5f5;
}

.password-modal h5 {
  margin-bottom: 12px;
  color: #f0e6c8;
  font-weight: 700;
}

.password-modal label {
  display: block;
  margin-top: 8px;
  margin-bottom: 4px;
  font-size: 0.82rem;
  color: #b8b3a8;
}

.password-modal .form-control {
  background: #111;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  color: #fff;
}

.error-text {
  display: block;
  min-height: 1em;
  color: #ff7a59;
  font-size: 0.75rem;
}

.update-btn {
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  font-weight: 700;
}
</style>

<style>
.password-popup.van-popup {
  background: #161616;
}
.password-popup .van-popup__close-icon {
  color: #f0e6c8;
}
</style>
